/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useEffect, useRef, useState } from 'react';
import { useLeftSidebarState } from '@jira/platform__controllers-layout/src/controllers/layout-controller/consumers/left-sidebar-controller/index.tsx';
import { useCurrentRoute } from '@jira/platform__utils-router/src/index.tsx';
// eslint-disable-next-line jira/restricted/@jira+platform__services-providers-project-context
import { useProjectContext } from '@jira/platform__services-providers-project-context/src/index.tsx';
import { usePageVisibility } from '@jira/platform__controllers-use-page-visibilty/src/index.tsx';
import { useAnalyticsEvents, fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';

import { useSpaStatePageReady } from '@atlassian/jira-spa-state-controller/src/components/page-ready-state/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { getPageDwellAttributes } from './useDwellTime.tsx';

const WAIT_DURATION = 5000;

/**
 * Dispatches AnalyticsEvent for when a user stays on a page for a set period of time
 */
const PageDwellAnalyticsListener = (): null => {
	const [hasFired, setHasFired] = useState(false);

	const route = useCurrentRoute();
	const routeName = route.name;

	const isReady = useSpaStatePageReady();
	const isVisible = usePageVisibility();
	const interval = useRef<unknown>(null);
	const { data: projectData } = useProjectContext();

	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { isCollapsed: isLeftSidebarCollapsed } = useLeftSidebarState();

	useEffect(() => {
		setHasFired(false);
	}, [routeName]);

	useEffect(() => {
		if (!isReady) {
			interval.current = null;
			return;
		}

		// If the page is visible, set the analytics event to run after the specified duration
		if (isVisible && !hasFired) {
			interval.current = setTimeout(() => {
				fireTrackAnalytics(createAnalyticsEvent({}), 'page dwelled', routeName, {
					containerId: projectData?.projectId,
					containerType: projectData?.projectType,
					isLeftSidebarCollapsed,
					...(fg('jira-page-dwell-custom-attributes') ? getPageDwellAttributes() : {}),
				});

				setHasFired(true);
			}, WAIT_DURATION);
		}

		return () => {
			// @ts-expect-error - TS2769 - No overload matches this call.
			interval.current = clearTimeout(interval.current);
		};
	}, [
		createAnalyticsEvent,
		hasFired,
		isReady,
		isVisible,
		routeName,
		projectData?.projectId,
		projectData?.projectType,
		isLeftSidebarCollapsed,
	]);

	return null;
};

export { PageDwellAnalyticsListener };
